var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Column, Entity, Index, ManyToOne, OneToMany } from 'typeorm';
import { Root } from './root.js';
import { BaseSnapshot } from './snapshot.js';
import { TransparencyAnalysis } from './analysis.js';
let CTSnapshot = class CTSnapshot extends BaseSnapshot {
    root;
    records;
    analyses;
};
__decorate([
    ManyToOne(() => Root, { nullable: true, onDelete: 'CASCADE' }),
    __metadata("design:type", Root)
], CTSnapshot.prototype, "root", void 0);
__decorate([
    Column('jsonb'),
    __metadata("design:type", Array)
], CTSnapshot.prototype, "records", void 0);
__decorate([
    OneToMany(() => TransparencyAnalysis, (a) => a.snapshot),
    __metadata("design:type", Array)
], CTSnapshot.prototype, "analyses", void 0);
CTSnapshot = __decorate([
    Entity({ name: 'transparency_snapshots' }),
    Index('idx_transparency_root_created', ['root', 'createdDate']),
    Index('idx_transparency_project_created', ['project', 'createdDate'])
], CTSnapshot);
export { CTSnapshot };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic25hcHNob3QtdHJhbnNwYXJlbmN5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2RvbWFpbi9tb2RlbHMvc25hcHNob3QtdHJhbnNwYXJlbmN5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsU0FBUyxFQUFFLE1BQU0sU0FBUyxDQUFDO0FBRXRFLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFDakMsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUM3QyxPQUFPLEVBQUUsb0JBQW9CLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFLOUMsSUFBTSxVQUFVLEdBQWhCLE1BQU0sVUFBVyxTQUFRLFlBQVk7SUFFMUMsSUFBSSxDQUFRO0lBR1osT0FBTyxDQUFtQztJQUcxQyxRQUFRLENBQTBCO0NBQ25DLENBQUE7QUFQQztJQURDLFNBQVMsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxJQUFJLEVBQUUsRUFBRSxRQUFRLEVBQUUsSUFBSSxFQUFFLFFBQVEsRUFBRSxTQUFTLEVBQUUsQ0FBQzs4QkFDeEQsSUFBSTt3Q0FBQztBQUdaO0lBREMsTUFBTSxDQUFDLE9BQU8sQ0FBQzs7MkNBQzBCO0FBRzFDO0lBREMsU0FBUyxDQUFDLEdBQUcsRUFBRSxDQUFDLG9CQUFvQixFQUFFLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFDOzs0Q0FDdkI7QUFSdkIsVUFBVTtJQUh0QixNQUFNLENBQUMsRUFBRSxJQUFJLEVBQUUsd0JBQXdCLEVBQUUsQ0FBQztJQUMxQyxLQUFLLENBQUMsK0JBQStCLEVBQUUsQ0FBQyxNQUFNLEVBQUUsYUFBYSxDQUFDLENBQUM7SUFDL0QsS0FBSyxDQUFDLGtDQUFrQyxFQUFFLENBQUMsU0FBUyxFQUFFLGFBQWEsQ0FBQyxDQUFDO0dBQ3pELFVBQVUsQ0FTdEIifQ==